var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 9.375H7.8125C6.5693 9.375 5.37701 9.86886 4.49794 10.7479C3.61886 11.627 3.125 12.8193 3.125 14.0625V35.9375C3.125 37.1807 3.61886 38.373 4.49794 39.2521C5.37701 40.1311 6.5693 40.625 7.8125 40.625H42.1875C43.4307 40.625 44.623 40.1311 45.5021 39.2521C46.3811 38.373 46.875 37.1807 46.875 35.9375V14.0625C46.875 12.8193 46.3811 11.627 45.5021 10.7479C44.623 9.86886 43.4307 9.375 42.1875 9.375ZM7.8125 12.5H42.1875C42.4842 12.5026 42.774 12.5897 43.023 12.751C43.2721 12.9124 43.47 13.1412 43.5938 13.4109L27.8578 25.5188C27.0384 26.149 26.0337 26.4907 25 26.4907C23.9663 26.4907 22.9616 26.149 22.1422 25.5188L6.40625 13.4109C6.52997 13.1412 6.72792 12.9124 6.97695 12.751C7.22598 12.5897 7.5158 12.5026 7.8125 12.5ZM42.1875 37.5H7.8125C7.3981 37.5 7.00067 37.3354 6.70765 37.0424C6.41462 36.7493 6.25 36.3519 6.25 35.9375V17.2359L20.2359 27.9953C21.603 29.0447 23.2782 29.6135 25.0016 29.6135C26.7249 29.6135 28.4001 29.0447 29.7672 27.9953L43.75 17.2359V35.9375C43.75 36.3519 43.5854 36.7493 43.2924 37.0424C42.9993 37.3354 42.6019 37.5 42.1875 37.5Z",
    fill: "#558564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9ee04704cb6d14ad894a45acc2475ab8.svg";
export { ForwardRef as ReactComponent };